import { render, staticRenderFns } from "./ConfirmGdpr.vue?vue&type=template&id=f67b971a&scoped=true"
import script from "./ConfirmGdpr.vue?vue&type=script&lang=js"
export * from "./ConfirmGdpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67b971a",
  null
  
)

export default component.exports